// 业务菜单
const menuData = {
    iconClass: "el-icon-menu",
    menuName: "业务管理",
    children: [{
        path: "/rhqy/service/basic",
        menuName: "基础数据管理",
        privilege: "",
        iconClass: "el-icon-s-operation",
        children: [
            // 已废弃
            // {
            //   path: "/rhqy/service/basic/base",
            //   menuName: "基地管理",
            //   privilege: ""
            // },
            {
                path: "/rhqy/service/basic/coordinate",
                menuName: "基地坐标管理",
                privilege: "c-base-mp-coordinate-query"
            },
            {
                path: "/rhqy/service/truck/GateManage",
                menuName: "门岗管理",
                privilege: "c-base-mp-door-query"
            },
            {
                path: "/rhqy/service/basic/serviceList",
                menuName: "预约业务管理",
                privilege: "c-base-mp-business-query"
            },
            {
                path: "/rhqy/service/basic/businessList",
                menuName: "车辆业务类型管理",
                privilege: "c-base-mp-carBusiness-query"
            },
            {
                path: "/rhqy/service/basic/goodsType",
                menuName: "货物种类管理",
                privilege: "c-base-mp-goods-query"
            },
            {
                path: "/rhqy/service/basic/warehouse",
                menuName: "装卸点",
                privilege: "c-base-mp-warehouse-query"
            },
            {
                path: "/rhqy/service/basic/samplePoint",
                menuName: "取样点",
                privilege: "c-base-mp-sampling-query"
            },
            {
                path: "/rhqy/service/basic/guide",
                menuName: "进厂指引管理",
                privilege: "c-base-mp-guide-query"
            },
            {
                path: "/rhqy/service/basic/beidouApiConfig",
                menuName: "北斗接口配置",
                privilege: "c-base-mp-beidou-config-query"
            },
            {
                path: "/rhqy/service/basic/companyPoundSystemConfig",
                menuName: "地磅系统配置",
                privilege: "c-base-mp-pound-system-config-query"
            },
            {
                path: "/rhqy/service/basic/companyC3Config",
                menuName: "C3配置",
                privilege: "c-base-mp-c3-config-query"
            },
            {
                path: "/rhqy/service/basic/bookingStrandedWarning",
                menuName: "逗留预警配置",
                privilege: "c-base-data-warning-view"
            },
            {
                path: "/rhqy/service/basic/autoCallingSchedule",
                menuName: "自动叫号时间维护",
                privilege: "c-base-mp-auto-calling-schedule-query"
            },
            {
                path: "/rhqy/service/safe/notice",
                menuName: "进厂安全告知书",
                privilege: "c-base-mp-safe-switch"
            },
            {
                path: "/rhqy/service/appoint/timeTplList",
                menuName: "预约时间模板",
                privilege: "c-base-mp-mtime-query"
            },
            {
                path: "/rhqy/service/appoint/timeCaseList",
                menuName: "预约时间实例",
                privilege: "c-base-mp-itime-query"
            },
            {
                path: "/rhqy/service/SuspectVehicleList",
                menuName: "车辆嫌疑名单",
                privilege: "c-base-mp-bd-query"
            },
            {
                path: "/rhqy/service/other",
                menuName: "其他设置",
                privilege: "c-base-mp-setting-warning"
            }
        ]
    },
        {
            path: '/rhqy/service/AccessCard',
            menuName: "发卡退卡管理",
            privilege: "",
            iconClass: "el-icon-postcard",
            children: [{
                path: "/rhqy/service/AccessCard/Send",
                menuName: "发卡操作",
                privilege: "c-card-send-query"
            },
                {
                    path: "/rhqy/service/AccessCard/Return",
                    menuName: "退卡操作",
                    privilege: "c-card-return-query"
                },
            ]
        },
        {
            path: '/rhqy/service/entryAuth',
            menuName: "车辆业务授权管理",
            privilege: "c-auth-record-query",
            iconClass: "el-icon-truck",
        },
        {
            path: '/rhqy/service/callingManage',
            menuName: "叫号管理",
            privilege: "c-calling-record-query",
            iconClass: "el-icon-s-order",
        },
        {
            path: '/rhqy/service/WeighConfirmManage/List',
            menuName: "过磅确认管理",
            privilege: "c-pound-record-query",
            iconClass: "el-icon-receiving",
        },
        {
            path: "/rhqy/service/clockIn",
            menuName: "发货打卡管理",
            privilege: "",
            iconClass: "el-icon-s-operation",
            children: [{
                path: "/rhqy/service/clockIn/VehicleReport",
                menuName: "车辆报备管理",
                privilege: "c-clock-report-query"
            },
                {
                    path: "/rhqy/service/clockIn/CollectionForm",
                    menuName: "预约送货收集表",
                    privilege: "c-clock-collect-query"
                },
                {
                    path: "/rhqy/service/clockIn/ClockList",
                    menuName: "发货打卡记录",
                    privilege: "c-clock-record-query"
                },
                {
                    path: "/rhqy/service/clockIn/CheckMonitor",
                    menuName: "打卡监控",
                    privilege: "c-clock-monitoring-query"
                },
            ]
        },
        {
            path: "/rhqy/service/AppointDeliveryRecord",
            menuName: "预约记录管理",
            privilege: "",
            iconClass: "el-icon-time",
            children: [{
                path: "/rhqy/service/AppointDeliveryRecord/List",
                menuName: "预约送货记录",
                privilege: "c-booking-delivery-query"
            },
                {
                    path: "/rhqy/service/AppointPickup/List",
                    menuName: "预约提货记录",
                    privilege: "c-booking-pickup-query"
                },
            ]
        },
        {
            path: "/rhqy/service/ReceiveSampleCollate",
            menuName: "收样核对管理",
            privilege: "c-cSample-record-query",
            iconClass: "el-icon-s-check",
        },
        {
            path: "/rhqy/service/Complaint/List",
            menuName: "投诉建议",
            privilege: "c-complaint-list-query",
            iconClass: "el-icon-warning-outline",
        },
        {
            path: "/rhqy/service/PriceManage/nowPrice",
            menuName: "价格管理",
            privilege: "c-price-record-query",
            iconClass: "el-icon-coin"
        },
        {
            path: "/rhqy/service/RailwayTicketManage",
            menuName: "铁路大票管理",
            privilege: "",
            iconClass: "el-icon-document",
            // 铁路大票后台按业务表拆成二级菜单，页面内部不再使用页签切换。
            children: [
                {
                    path: "/rhqy/service/RailwayTicketManage/region",
                    menuName: "铁路区域定价",
                    privilege: "c-railway-region-query"
                },
                {
                    path: "/rhqy/service/RailwayTicketManage/factory",
                    menuName: "铁路专厂价格",
                    privilege: "c-railway-factory-query"
                },
                {
                    path: "/rhqy/service/RailwayTicketManage/collect",
                    menuName: "铁路大票收集表",
                    privilege: "c-railway-collect-query"
                }
            ]
        },
        {
            path: "/rhqy/service/announcement",
            menuName: "公告管理",
            privilege: "c-notice-record-query",
            iconClass: "el-icon-chat-line-square"
        },
        {
            path: "/rhqy/service/report",
            menuName: "报表管理",
            privilege: "",
            iconClass: "el-icon-data-analysis",
            children: [
                {
                    path: "/rhqy/service/report/SupplierEvaluation",
                    menuName: "供应商评估表",
                    privilege: "c-mpReport-record-unitList"
                },
                {
                    path: "/rhqy/service/report/ChipClockInStatistics",
                    menuName: "木片打卡统计表",
                    privilege: "c-mpReport-record-clockList"
                },
                {
                    path: "/rhqy/service/report/ChipDeliverGoodsDailyPaper",
                    menuName: "木片送货情况日报",
                    privilege: "c-mpReport-record-deliverList"
                },
                {
                    path: "/rhqy/service/report/InspectionDetail",
                    menuName: "质检明细表",
                    privilege: "c-mpReport-record-inspectList"
                },
                {
                    path: "/rhqy/service/report/WarehouseQueue",
                    menuName: "装卸点车辆排队情况统计",
                    privilege: "c-mpReport-record-warehouseQueue"
                },
            ]
        },
        {
            path: "/rhqy/service/oplog",
            menuName: "操作日志",
            privilege: "c-base-mp-log-list",
            iconClass: "el-icon-tickets"
        },
    ]
};

export {
    menuData
};
